<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('处理状态')">
                <a-select v-model="queryParam.status" :placeholder="$t('请选择')">
                  <a-select-option v-for="(item, index) in statusArr" :key="`status-${index}`" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('举报原因')">
                <a-select v-model="queryParam.type" :placeholder="$t('请选择')">
                  <a-select-option v-for="(item, index) in typeArr" :key="`type-${index}`" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建时间')">
                <cy-range-picker
                  :start.sync="queryParam.createBeginTime"
                  :end.sync="queryParam.createEndTime"
                ></cy-range-picker>
              </a-form-item>
            </a-col>
            <template v-if="advanced"> </template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <!--            <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['problem:type:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button> -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cooking:dynamictopic:remove']">
          <a-icon type="delete" />{{ $t('删除') }}
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['cooking:dev:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form v-if="visible" ref="createForm" @refresh="getList" @close="visible = false" />
      <!-- 详情 -->
      <detail-form v-if="detailVisible" ref="detailForm" @refresh="getList" @close="detailVisible = false" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="consultImgUrl" slot-scope="text, record">
          <div v-viewer>
            <img style="width: 50px; height: 50px" :src="record.consultImgUrl" alt="" srcset="" />
          </div>
        </span>
        <span slot="remark" slot-scope="text, record">
          <div v-viewer v-if="record.remark">
            <img
              style="width: 20px; height: 20px"
              v-for="item in record.remark.split(',')"
              :key="item"
              :src="item"
              alt=""
              srcset=""
            />
          </div>
        </span>
        <span slot="status" slot-scope="text, record">
          {{ record.status | filterCommon(statusArr, 'label') }}
        </span>
        <span slot="type" slot-scope="text, record">
          {{ record.type | filterCommon(typeArr, 'label') }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!-- <a-divider type="vertical" v-hasPermi="['cooking:dynamictopic:query']" />
          <a @click="handleDetail(record.id)" v-hasPermi="['cooking:dynamictopic:query']">
            {{$t('详情')}}
          </a> -->
          <!-- <a-divider type="vertical" v-hasPermi="['cooking:report:edit']" />
          <a @click="handleAdd(record.id)" v-hasPermi="['cooking:report:edit']">
            {{$t('修改')}}
          </a> -->
          <a-divider type="vertical" v-hasPermi="['cooking:report:edit']" />
          <a @click="handleAudit(record.id)" v-hasPermi="['cooking:report:edit']">
            {{ $t('审核') }}
          </a>
          <!-- <a-divider type="vertical" v-hasPermi="['cooking:dynamictopic:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['cooking:dynamictopic:remove']">
            {{$t('删除')}}
          </a> -->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `${$t('共')} ${total} ${$t('条')}`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delObj, fetchList, putTop, putObj } from './api'
import CreateForm from './modules/CreateForm'
import DetailForm from './modules/Detail'
import CyRangePicker from '@/components/CyRangePicker'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Type',
  components: {
    CreateForm,
    DetailForm,
    CyRangePicker
  },
  mixins: [tableMixin],
  data() {
    return {
      detailVisible: false,
      statusArr: [
        { value: 0, label: this.$t('待处理') },
        { value: 1, label: this.$t('已处理') }
      ],
      typeArr: [
        { value: 1, label: this.$t('骚扰') },
        { value: 2, label: this.$t('诈骗') },
        { value: 3, label: this.$t('冒充') },
        { value: 4, label: this.$t('侵权') },
        { value: 5, label: this.$t('伪冒') },
        { value: 6, label: this.$t('其他') }
      ],
      visible: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
        type: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      },
      columns: [
        { title: this.$t('被举报用户名称'), dataIndex: 'userName', align: 'center', ellipsis: true },
        {
          title: this.$t('举报原因'),
          dataIndex: 'type',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'type' }
        },
        {
          title: this.$t('举报证据'),
          dataIndex: 'remark',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'remark' }
        },
        { title: this.$t('处理结果'), dataIndex: 'result', align: 'center', ellipsis: true },
        {
          title: this.$t('处理状态'),
          dataIndex: 'status',
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      form: {
        id: '',
        result: '',
        status: 0
      }
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    // 审核
    handleAudit(id) {
      this.form.id = id

      this.$confirm({
        title: this.$t('审核信息'),
        content: (h) => (
          <div>
            <a-radio-group v-model={this.form.status} style={{ marginBottom: '20px' }}>
              <a-radio value={0}>{this.$t('待处理')}</a-radio>
              <a-radio value={1}>{this.$t('已处理')}</a-radio>
            </a-radio-group>
            <a-textarea v-model={this.form.result} placeholder={this.$t('请输入')}></a-textarea>
          </div>
        ),
        onOk: () => {
          if (this.form.status === 0 && !this.form.result) {
            this.$message.error(this.$t('请输入理由'))
            return Promise.reject(new Error('请输入理由'))
          }
          putObj(this.form).then((res) => {
            this.form.status = 0
            this.form.result = ''
            this.getList()
          })
        },
        onCancel: () => {
          console.log('Cancel')
        }
      })
    },
    handleZd(id) {
      putTop({ id }).then((res) => {
        this.getList()
      })
    },
    handleDetail(id) {
      this.detailVisible = true
      this.$nextTick(() => {
        this.$refs.detailForm.init(id)
      })
    },
    handleAdd(id) {
      this.visible = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.createForm.init(id)
        }, 100)
      })
    },
    /** 查询常见问题分类列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
        type: undefined,
        createBeginTime: undefined,
        createEndTime: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确认删除所选中数据?'),
        onOk() {
          const data = []
          that.ids.map((id) => data.push({ id: id }))
          delObj(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(this.$t('删除成功'), 3)
          })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出?'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download(
            'problem/type/export',
            {
              ...that.queryParam
            },
            `常见问题分类_${new Date().getTime()}.xls`
          )
        },
        onCancel() {}
      })
    }
  }
}
</script>
